

import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import VideoDuration from '/components/Video/VideoDuration';
import PlayIconButton from '/components/playIconButton';
import { Typography } from '@material-ui/core';
import fontUniOrConvertZawgyi from '/utils/fontUniOrConvertZawgyi';
import { createGlobalStyle } from "styled-components";
import "react-image-lightbox/style.css";
import Lightbox from "react-image-lightbox";

const CarouselStyleComponent = createGlobalStyle`
@font-face {
    font-family:"DuwunFont";
    src:url("https://duwun-data.sgp1.cdn.digitaloceanspaces.com/fonts/v1.6/Duwun_lite_v1.6.woff2") format("woff2"),
        url("https://duwun-data.sgp1.cdn.digitaloceanspaces.com/fonts/v1.6/Duwun_lite_v1.6.woff") format("woff"),
        url("https://duwun-data.sgp1.cdn.digitaloceanspaces.com/fonts/v1.6/Duwun_lite_v1.6.ttf") format('truetype');
    font-display: swap;
  }
  `
const styles =({
  root: {
    maxWidth: '100%',
    margin: 20,
    position: 'relative',
    cursor: 'pointer'
  },
  media: {
    height: 140,
  },
  title: {
    padding: 14,
    fontFamily: 'DuwunFont',
    fontSize: 14,
    overflowWrap: 'break-word'
  },
});
class EventGalleryCard extends Component {
    constructor(props) {
      super(props);
      this.state = {
          columnWidth:'',
          photoIndex: 0,
          isOpen: false,
      }
    }
    render(){
    const { classes, item, items, index, active } = this.props;
    const { photoIndex, isOpen } = this.state;
    return (
        <>
        <CarouselStyleComponent />
        <Card className={classes.root} onClick={() => active(index, items)}>
            <CardMedia
            className={classes.media}
            image={item.cover.thumb}
            title="Image"
            />
            <Typography className={classes.title} component="p">
                {fontUniOrConvertZawgyi(item.name)}
            </Typography>
          
        </Card>
            {/* ************************** For light box ************************* */}

            {/* {isOpen && (
                <Lightbox
                mainSrc={items[photoIndex].cover.teaser}
                nextSrc={items[(photoIndex + 1) % items.length].cover.teaser}
                prevSrc={items[(photoIndex + items.length - 1) % items.length].cover.teaser}
                onCloseRequest={() => this.setState({ isOpen: false })}
                onMovePrevRequest={() =>
                    this.setState({
                    photoIndex: (photoIndex + items.length - 1) % items.length
                    })
                }
                onMoveNextRequest={() =>
                    this.setState({
                    photoIndex: (photoIndex + 1) % items.length
                    })
                }
                />
            )} */}
        </>
    );
    }
}
export default withStyles(styles)(EventGalleryCard);
